// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ljVc","label":"styles_label__HJMUO"};